import React, { type FC } from 'react';
import { Space, Text } from '@g2u/ui-kit';

import { type WithOptionalDataTest } from 'types';

export namespace Intro {
  export type Props = WithOptionalDataTest;

  export const $: FC<Props> = () => {
    return (
      <Space.$ direction={Space.Direction.Horizontal} className='script-box'>
        <Text.$ size={Text.Size.SM} accent>
          Reference
        </Text.$>
        <Text.$ size={Text.Size.SM} mark>
          Read exactly as written
        </Text.$>
        <Text.$ size={Text.Size.SM} type="secondary" italic>
          *Note*
        </Text.$>
      </Space.$>
    );
  };
}
